import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
import { trackInitiateCheckout } from '../utils/metaPixel';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-slate-600/40 bg-blue-950 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-61" data-mp="15bsodlj70gm7">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-62" data-mp="1jbadk20ehvw3">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-stone-50 sm:text-4xl" data-id="element-63" data-mp="1ed0kbwy8l5d4">
          <span className="inline-flex items-center gap-2" data-id="element-64" data-mp="1t252je5179l8">
            <ZapIcon className="h-8 w-8 shrink-0 text-yellow-400" aria-hidden="true" data-id="element-65" data-mp="1o3lhdfy9i1tx" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-amber-400 sm:text-2xl" data-id="element-66" data-mp="224eco2we10y3">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-67" data-mp="n64elx7608q5">
          Created for diesel mechanics, maintenance technicians and generator set operators worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-8 w-full sm:w-auto" data-id="element-68" data-mp="x3ir5lpywdd6">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-69" data-mp="163fad7tl8k0u">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-70" data-mp="1b1grhn7ge99o">
              <CheckIcon className="h-4 w-4 text-yellow-400" aria-hidden="true" data-id="element-71" data-mp="1fvkz88ojmlbt" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}